module.exports = __webpack_public_path__ + "static/media/logo-white-d.e3c92f0a.png";